module.exports = __webpack_public_path__ + "static/media/billSummaryTemplate.53ab6316.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/views/invoice/asset/billSummaryTemplate.xlsx
// module id = 734
// module chunks = 0